module.exports = __webpack_public_path__ + "organigramme/img/gta-logo-black.f2385f15.svg";